export const peso = new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP" });
export const shortDate = new Intl.DateTimeFormat("en-PH", { month: "short", day: "numeric" });
export const timeAgo = (value: string) => {
  const minutes = Math.max(1, Math.round((Date.now() - new Date(value).getTime()) / 60_000));
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return shortDate.format(new Date(value));
};

